import React, { useEffect, useState } from "react";
import styles from "../../../styles/modal/bhet.module.css";
import classes from "../../../styles/pujaRegistrationBhet.module.css";
import { Box, Divider, Modal, Stack, Typography } from "@mui/material";
import NavBar from "../NavBar";
import RegistrationBtn from "../registrationBtn";
import RegistrationStepper from "../registrationStepper";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import Image from "next/legacy/image";
import flowerIcon from "../../../../../public/assets/newEvent/pujaDetails/flowerIcon.webp";
import theme from "src/globalModule/styles/theme";
import PujaBhetCard from "../pujaBhetCard";
import { SMS_TEMPLATE, WEB_ENGAGE } from "@utils/constants";
import { deleteRegistrationDetails, setOTPVerificationKey } from "@utils/reduxToolkit/features/registrationDetailsSlice";
import { useDispatch, useSelector } from "react-redux";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { trackEvent } from "@utils/analytics/event-analytics";
import { createJuspaySession, getRazorpayPaymentOrderID, postBhetDaan } from "src/pujaModule/queries/pujas.queries";
import { deleteSubEventDetails } from "@utils/reduxToolkit/features/subEventSlice";
import RazorpayHandler from "@utils/razorpay/handler";
import { deleteCart } from "@utils/reduxToolkit/features/cartSlice";
import * as Sentry from "@sentry/nextjs";
function RegistrationBhet({
  showBhetModal,
  setShowBhetModal
}) {
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const dispatch = useDispatch();
  const {
    eventid
  } = router.query;

  //   const [openBhet, setOpenBhet] = useState(true);
  const [stepNo, setStepNo] = useState(1);
  const [templeName, setTempleName] = useState("");
  const [generalBhet, setGeneralBhet] = useState([]);
  const [specificBhet, setSpecificBhet] = useState([]);
  const [mainPrasadSubEvents, setMainPrasadSubEvents] = useState([]);
  const [errorModal, setErrorModal] = useState({
    open: false,
    heading: "",
    message: "",
    acceptMethod: () => {},
    icon: null
  });
  const [payDakshinaLoader, setPayDakshinaLoader] = useState(false);
  const {
    subEventDetails
  } = useSelector(state => state.subEventDetails);
  const {
    registrationDetails,
    bhetDaanDetails
  } = useSelector(state => state.pujaBooking);
  const {
    cart,
    totalAmount,
    pujaAmount
  } = useSelector(state => state.cart);
  useEffect(() => {
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_BHET_DAAN_CARD + " " + WEB_ENGAGE.EVENT_NAMES.SCREEN_VIEWED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_BHET_DAAN_CARD,
      [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: subEventDetails?.eventName_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.SUB_KRIYA_NAME]: subEventDetails?.name_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: Number(subEventDetails?.eventRegistrationAmount),
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: subEventDetails?.deityName,
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventid,
      [WEB_ENGAGE.EVENT_PROPERTIES.SUB_EVENT_URL_EXTENSION]: subEventDetails?.urlExtension
    });
  }, []);
  useEffect(() => {
    if (bhetDaanDetails?.generalBhetDaanSubEvents) {
      setGeneralBhet(bhetDaanDetails?.generalBhetDaanSubEvents);
    }
    if (bhetDaanDetails?.specificBhetDaanSubEvents) {
      setSpecificBhet(bhetDaanDetails?.specificBhetDaanSubEvents);
    }
    if (bhetDaanDetails?.mainPrasadSubEvents) {
      setMainPrasadSubEvents(bhetDaanDetails?.mainPrasadSubEvents);
    }
    dispatch(setOTPVerificationKey(null));
  }, [bhetDaanDetails]);
  useEffect(() => {
    if (subEventDetails) {
      setTempleName(subEventDetails?.templeName);
    }
  }, [subEventDetails]);
  const handleCloseBhet = () => {
    setShowBhetModal(false);
  };
  const cartSubmit = async e => {
    setPayDakshinaLoader(true);
    e.preventDefault();
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_BHET_DAAN_CARD + " " + WEB_ENGAGE.BUTTON_NAMES.POSITIVE + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_REGISTRATION_BHET_DAAN_CARD,
      [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.POSITIVE,
      [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: subEventDetails?.eventName_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.SUB_KRIYA_NAME]: subEventDetails?.name_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.MAIN_PUJA_PRICE]: Number(pujaAmount),
      [WEB_ENGAGE.EVENT_PROPERTIES.BHET_PUJA_PRICE]: cart.length > 0 ? Number(totalAmount) - Number(pujaAmount) : 0,
      [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: cart.length > 0 ? Number(totalAmount) : Number(pujaAmount),
      [WEB_ENGAGE.EVENT_PROPERTIES.TOTAL_PUJA_PRICE]: cart.length > 0 ? Number(totalAmount) : Number(pujaAmount),
      [WEB_ENGAGE.EVENT_PROPERTIES.BHET_COUNT]: cart.length,
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: subEventDetails?.deityName,
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventid,
      [WEB_ENGAGE.EVENT_PROPERTIES.SUB_EVENT_URL_EXTENSION]: subEventDetails?.urlExtension
    });
    if (registrationDetails) {
      const cartItems = cart.map(item => {
        return {
          registrationID: registrationDetails.registrationID,
          eventID: item.eventID,
          subEventID: item.subEventID,
          uid: registrationDetails.uid,
          quantity: item.quantity,
          eventStart: item.start,
          costPrice: item.amount,
          sellingPrice: item.eventRegistrationAmount
        };
      });
      const res = await postBhetDaan({
        registrationID: registrationDetails.registrationID,
        allBhets: cartItems
      });
      if (res && res?.success) {
        startPaymentHandler();
      } else {
        setErrorModal({
          open: true,
          heading: `${t("puja-registration")}`,
          message: `${t("something-went-wrong-please-try-again")}`,
          acceptMethod: () => setErrorModal({
            ...errorModal,
            open: false
          }),
          icon: <ErrorOutlineOutlinedIcon sx={{
            fontSize: "3rem",
            color: "red"
          }} />
        });
      }
    } else {
      Sentry.captureException(new Error("Registration Details not found in puja booking" + JSON.stringify(registrationDetails)));
      setShowBhetModal(false);
      // setErrorModal({
      //   open: true,
      //   heading: `${t("puja-registration")}`,
      //   message: `${t("something-went-wrong-please-try-again")}`,
      //   acceptMethod: () => setErrorModal({ ...errorModal, open: false }),
      //   icon: (
      //     <ErrorOutlineOutlinedIcon sx={{ fontSize: "3rem", color: "red" }} />
      //   ),
      // });
    }
  };

  // const startPaymentHandler1 = async (e) => {
  //   if (e) e.preventDefault();
  //   let [firstName, lastName] = registrationDetails.name.split(" ");

  //   const response = await createJuspaySession({
  //     uid: registrationDetails.uid,
  //     registrationID: registrationDetails.registrationID,
  //     eventUrlExtension: eventid,
  //     subEventUrlExtension: subEventDetails?.urlExtension,
  //     contact: registrationDetails.contact,
  //     firstName,
  //     lastName,
  //     amount: cart.length > 0 ? totalAmount : pujaAmount,
  //     // amount: 1,
  //     source: SMS_TEMPLATE.WEBSITE,
  //     language: router.locale,
  //     isDigital: false,
  //     return_url: `${process.env.NEXT_PUBLIC_APP_HOSTNAME}/${router.locale}/puja/registration/${eventid}/${subEventDetails.urlExtension}/success`,
  //   });
  //   setPayDakshinaLoader(false);

  //   if (response.data) {
  //     window.location.replace(response.data.payment_links.web);
  //   }
  // };

  const startPaymentHandler = async e => {
    if (e) e.preventDefault();
    const orderID = await getRazorpayPaymentOrderID({
      amount: cart.length > 0 ? totalAmount : pujaAmount
    });
    const paymentData = {
      orderID: orderID.data,
      registrationID: registrationDetails.registrationID,
      amount: cart.length > 0 ? totalAmount : pujaAmount,
      source: SMS_TEMPLATE.WEBSITE,
      contact: registrationDetails.contact,
      language: router.locale,
      userName: registrationDetails.name,
      uid: registrationDetails.uid,
      eventData: {
        eventID: registrationDetails.eventID,
        subEventID: registrationDetails.subEventID,
        subEventName: subEventDetails.name
      }
    };
    // console.log("paymentData", paymentData);

    setPayDakshinaLoader(false);
    RazorpayHandler({
      amount: paymentData.amount,
      data: paymentData,
      onSuccessHandler: () => {
        paymentSuccessHandler(WEB_ENGAGE.PAYMENT_MODES.PREPAID, paymentData);
      },
      onErrorHandler: () => {
        paymentErrorHandler(WEB_ENGAGE.PAYMENT_MODES.PREPAID, paymentData);
      }
    });
  };
  const paymentSuccessHandler = async (paymentMode, paymentData) => {
    const subEventUrlExtension = subEventDetails?.urlExtension;
    dispatch(deleteCart());
    dispatch(deleteSubEventDetails());
    dispatch(deleteRegistrationDetails());
    trackEvent(WEB_ENGAGE.EVENT_NAMES.KRIYA_REGISTRATION_SUCCESS, {
      [WEB_ENGAGE.EVENT_PROPERTIES.USER_NAME]: paymentData.userName,
      [WEB_ENGAGE.EVENT_PROPERTIES.USER_ID]: paymentData.uid,
      [WEB_ENGAGE.EVENT_PROPERTIES.PHONE_NUMBER]: paymentData.contact,
      [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: subEventDetails.eventName_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.SUB_KRIYA_NAME]: subEventDetails.name_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.MAIN_PUJA_PRICE]: Number(pujaAmount),
      [WEB_ENGAGE.EVENT_PROPERTIES.BHET_PUJA_PRICE]: cart.length > 0 ? Number(totalAmount) - Number(pujaAmount) : 0,
      [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: cart.length > 0 ? Number(totalAmount) : Number(pujaAmount),
      [WEB_ENGAGE.EVENT_PROPERTIES.TOTAL_PUJA_PRICE]: cart.length > 0 ? Number(totalAmount) : Number(pujaAmount),
      [WEB_ENGAGE.EVENT_PROPERTIES.BHET_COUNT]: cart.length,
      [WEB_ENGAGE.EVENT_PROPERTIES.REGISTRATION_ID]: paymentData.registrationID,
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: subEventDetails?.deityName,
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventid,
      [WEB_ENGAGE.EVENT_PROPERTIES.SUB_EVENT_URL_EXTENSION]: subEventUrlExtension
    });
    // router.push(`/puja/registration?registrationID=${registrationID}`);
    // router
    //   .replace(
    //     `/puja/registration?registrationID=${registrationDetails.registrationID}&receipt=true`
    //   )
    //   .then(() => {
    //     router.reload();
    //   });

    window.location.href = `${process.env.NEXT_PUBLIC_APP_HOSTNAME}/${router.locale}/puja/registration?registrationID=${registrationDetails.registrationID}&receipt=true`;
  };
  const paymentErrorHandler = async paymentMode => {
    const subEventUrlExtension = subEventDetails?.urlExtension;
    trackEvent(WEB_ENGAGE.EVENT_NAMES.KRIYA_REGISTRATION_FAILURE, {
      [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: subEventDetails.eventName_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.SUB_KRIYA_NAME]: subEventDetails.name_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.MAIN_PUJA_PRICE]: Number(pujaAmount),
      [WEB_ENGAGE.EVENT_PROPERTIES.BHET_PUJA_PRICE]: cart.length > 0 ? Number(totalAmount) - Number(pujaAmount) : 0,
      [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: cart.length > 0 ? Number(totalAmount) : Number(pujaAmount),
      [WEB_ENGAGE.EVENT_PROPERTIES.TOTAL_PUJA_PRICE]: cart.length > 0 ? Number(totalAmount) : Number(pujaAmount),
      [WEB_ENGAGE.EVENT_PROPERTIES.BHET_COUNT]: cart.length,
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: subEventDetails?.deityName,
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventid,
      [WEB_ENGAGE.EVENT_PROPERTIES.SUB_EVENT_URL_EXTENSION]: subEventUrlExtension
    });
    router.reload();
    setErrorModal({
      open: true,
      heading: `${t("puja-registration")}`,
      message: `${t("something-went-wrong-please-try-again")}`,
      acceptMethod: () => setErrorModal({
        ...errorModal,
        open: false
      }),
      icon: <ErrorOutlineOutlinedIcon sx={{
        fontSize: "3rem",
        color: "red"
      }} />
    });
  };
  return <>
      <Modal open={showBhetModal} onClose={handleCloseBhet} data-sentry-element="Modal" data-sentry-source-file="bhet.jsx">
        <Box className={styles.modalContainer} data-sentry-element="Box" data-sentry-source-file="bhet.jsx">
          <NavBar activeStep={stepNo} setActiveStep={setStepNo} name={t("puja-booking")} closeModal={handleCloseBhet} data-sentry-element="NavBar" data-sentry-source-file="bhet.jsx" />
          <Stack sx={{
          mt: "55px"
        }} data-sentry-element="Stack" data-sentry-source-file="bhet.jsx">
            <RegistrationStepper activeStep={stepNo} data-sentry-element="RegistrationStepper" data-sentry-source-file="bhet.jsx" />

            <Stack sx={{
            mb: "80px",
            background: "#FFFEFA"
          }} padding={"20px 17px"} spacing={"25px"} data-sentry-element="Stack" data-sentry-source-file="bhet.jsx">
              {mainPrasadSubEvents.length > 0 && <Stack>
                  <div className={classes.bhetSectionContainer}>
                    <Image src={flowerIcon} alt="flower-icon" width={"20px"} height={"30px"} />

                    <Typography className={classes.bhetSectionHeader}>
                      {t("prasad-delivery")}
                    </Typography>
                  </div>

                  <Stack direction={"column"} spacing={2}>
                    {mainPrasadSubEvents?.map((subEvent, index) => <PujaBhetCard key={index} data={subEvent} subEventDetails={subEventDetails} eventid={eventid} subeventid={subEventDetails?.urlExtension} />)}
                  </Stack>
                </Stack>}
              {specificBhet.length > 0 && mainPrasadSubEvents.length > 0 && <Divider />}

              {specificBhet.length > 0 && <Stack>
                  <div className={classes.bhetSectionContainer}>
                    <Image src={flowerIcon} alt="flower-icon" width={"20px"} height={"30px"} />

                    <Typography className={classes.bhetSectionHeader}>
                      {t("offer-bhet-at")} {templeName} {t("with-your-puja")}
                    </Typography>
                  </div>

                  <Stack direction={"column"} spacing={2}>
                    {specificBhet?.map((subEvent, index) => <PujaBhetCard key={index} data={subEvent} subEventDetails={subEventDetails} eventid={eventid} subeventid={subEventDetails?.urlExtension} />)}
                  </Stack>
                </Stack>}

              {specificBhet.length > 0 && generalBhet.length > 0 && <Divider />}

              {generalBhet.length > 0 && <Stack>
                  <div className={classes.bhetSectionContainer}>
                    <Image src={flowerIcon} alt="flower-icon" width={"20px"} height={"30px"} />

                    <Typography className={classes.bhetSectionHeader}>
                      {t("offer-bhet-at-other-holy-places-in-india")}
                    </Typography>
                  </div>

                  <Stack direction={"column"} spacing={2}>
                    {generalBhet?.map((subEvent, index) => <PujaBhetCard key={index} data={subEvent} />)}
                  </Stack>
                </Stack>}

              <div className={classes.registrationDisclaimer}>
                <Typography sx={{
                fontSize: "14px",
                color: theme.palette.text.secondaryDark,
                textAlign: "center"
              }} data-sentry-element="Typography" data-sentry-source-file="bhet.jsx">
                  {t("name-gotra-and-prasad-delivery-address-will-be-asked-after-payment-completion")}
                </Typography>
              </div>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      <div className={classes.bottomContainer}>
        <RegistrationBtn btnText={`${t("pay-dakshina")} `} addOnPageButton={true} setProps={cartSubmit} postionFixed={true} loading={payDakshinaLoader} data-sentry-element="RegistrationBtn" data-sentry-source-file="bhet.jsx" />
      </div>
    </>;
}
export default RegistrationBhet;